import { Countries } from 'src/app/app.consts';

const creddoPage = 'https://creddo.com/fi/';

export const environment = {
  production: true,
  host: 'https://api.creddo.com/fi',
  summaryRedirectUrl: 'https://customer.creddo.com/fi/',
  gtmId: 'GTM-MS524R4',
  phoneNumberRegex:
    /^((([\+][\s]{0,1})|([0]{2}[\s-]{0,1}))([358]{3})([\s-]{0,1})|([0]{1}))(([1-9]{1}[0-9]{0,1})([\s-]{0,1})([0-9]{2,4})([\s-]{0,1})([0-9]{2,4})([\s-]{0,1}))([0-9]{0,3}){1}$/,
  countryPrefix: '00358',
  defaultLanguage: 'fi',
  creddoPage,
  country: Countries.FINLAND,
  currency: 'EUR',
  locale: 'fi-FI',
  tos: `${creddoPage}kayttoehdot/`,
  tosReseller: `${creddoPage}kayttoehdot/`,
  faq: `${creddoPage}yrityslaina/#faq`,
  faqPartner: `${creddoPage}yrityslaina/#faq`,
  pageTitle: 'Yrityslainahakemus | Creddo',
  pageDescription:
    'Täytä yrityslainahakemus ja saat pian useita lainatarjouksia yrityksellesi. Täytä ja lähetä hakemus.',
  hsScriptId: '',
  hj: '2953635',
};
